import { useCallback, useState } from "react";
import type { SortOrder, TableSortState } from "../types";

type UseTableSortParams = {
	onSortApplied?: () => void;
};

export function useTableSort(params: UseTableSortParams = {}) {
	const { onSortApplied } = params;
	const [sortState, setSortState] = useState<TableSortState | null>(null);

	const handleSortSelect = useCallback(
		(columnKey: string, order: SortOrder | null) => {
			setSortState(order ? { columnKey, order } : null);
			onSortApplied?.();
		},
		[onSortApplied],
	);

	return {
		sortState,
		handleSortSelect,
	};
}
